import script from "./DropdownBrands.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownBrands.vue?vue&type=script&setup=true&lang=js"

import "./DropdownBrands.vue?vue&type=style&index=0&id=48709541&lang=scss"

const __exports__ = script;

export default __exports__